export type VisibleRangeProfileKind = 'volume' | 'liquidation' | 'openInterest'
export type VisibleRangeProfileRowsLayout = 'numberOfRows' | 'ticksPerRow'
export type VisibleRangeProfileVolumeMode = 'upDown' | 'total' | 'delta'

export type VisibleRangeProfileDisplaySettings = {
  rowsLayout: VisibleRangeProfileRowsLayout
  rowSize: number
  volumeMode: VisibleRangeProfileVolumeMode
  valueAreaPercent: number
}

export const VISIBLE_RANGE_PROFILE_UNIT_INPUT_ID = 'measure'
export const VISIBLE_RANGE_PROFILE_ROWS_LAYOUT_INPUT_ID = 'rowsLayout'
export const VISIBLE_RANGE_PROFILE_ROW_SIZE_INPUT_ID = 'rowSize'
export const VISIBLE_RANGE_PROFILE_VOLUME_MODE_INPUT_ID = 'volumeMode'
export const VISIBLE_RANGE_PROFILE_VALUE_AREA_INPUT_ID = 'valueAreaPercent'

export const DEFAULT_VISIBLE_RANGE_PROFILE_SETTINGS: VisibleRangeProfileDisplaySettings = {
  rowsLayout: 'numberOfRows',
  rowSize: 24,
  volumeMode: 'upDown',
  valueAreaPercent: 70,
}

export const DEFAULT_VISIBLE_RANGE_PROFILE_SETTINGS_BY_KIND: Record<
  VisibleRangeProfileKind,
  VisibleRangeProfileDisplaySettings
> = {
  volume: { ...DEFAULT_VISIBLE_RANGE_PROFILE_SETTINGS },
  liquidation: { ...DEFAULT_VISIBLE_RANGE_PROFILE_SETTINGS },
  openInterest: { ...DEFAULT_VISIBLE_RANGE_PROFILE_SETTINGS },
}

export const VISIBLE_RANGE_PROFILE_STUDIES = {
  volume: {
    name: 'OrderX Volume Delta Profile',
    shortDescription: 'Volume Delta Profile',
  },
  liquidation: {
    name: 'OrderX Liquidation Profile',
    shortDescription: 'Liquidation Profile',
  },
  openInterest: {
    name: 'OrderX Open Interest Profile',
    shortDescription: 'Open Interest Profile',
  },
} as const satisfies Record<VisibleRangeProfileKind, { name: string; shortDescription: string }>

export function getVisibleRangeProfileKindByStudyName(
  studyName: string
): VisibleRangeProfileKind | null {
  const entry = (
    Object.entries(VISIBLE_RANGE_PROFILE_STUDIES) as Array<
      [VisibleRangeProfileKind, (typeof VISIBLE_RANGE_PROFILE_STUDIES)[VisibleRangeProfileKind]]
    >
  ).find(([, definition]) => definition.name === studyName)
  return entry ? entry[0] : null
}
